import { NgModule } from '@angular/core';
import { FiNumericValidatorDirective } from './numeric-validator.directive';

@NgModule({
    declarations: [FiNumericValidatorDirective],
    exports: [FiNumericValidatorDirective],
})
export class FiNumericValidatorModule {}
